<template>
  <div class="member-info">
    <div class="member-info-box">
      <div class="member-info-box-title">
        <div>会员等级</div>
      </div>
      <div class="member-info-box-content">
        <div class="member-info-box-text">{{ memberInfo.memberLevelName }}</div>
      </div>
    </div>
    <div class="member-info-box">
      <div class="member-info-box-title">
        <div>可用积分</div>
        <el-button
          style="margin-left: 8px"
          size="mini"
          type="text"
          v-has-permi="['user_send_score']"
          @click="handleScore(baseUserInfoVo)"
        >
          发积分
        </el-button>
      </div>
      <div class="member-info-box-content">
        <el-button type="text" @click="openStatisticsDialog(1)">
          {{ memberInfo.score }}
        </el-button>
      </div>
    </div>
    <div class="member-info-box">
      <div class="member-info-box-title">
        <div>成长值</div>
      </div>
      <div class="member-info-box-content">
        <el-button type="text" @click="openStatisticsDialog(2)">
          {{ memberInfo.exp }}
        </el-button>
      </div>
    </div>
    <div class="member-info-box">
      <div class="member-info-box-title">
        <div>可用优惠券</div>
        <el-button
          style="margin-left: 8px"
          size="mini"
          type="text"
          v-has-permi="['user_send_coupon']"
          @click="handleCoupon(baseUserInfoVo)"
        >
          发券
        </el-button>
      </div>
      <div class="member-info-box-content">
        <div class="member-info-box-text">{{ memberInfo.couponCount }}</div>
      </div>
    </div>
  </div>
</template>

<script >
import { inject, computed } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const userInfo = inject('userInfo');
  // 会员信息
  const memberInfo = computed(() => {
    return userInfo && userInfo.value && userInfo.value.memberInfo ? userInfo.value.memberInfo : {};
  });
  // 基础信息
  const baseUserInfoVo = computed(() => {
    return userInfo && userInfo.value && userInfo.value.baseUserInfoVo ? userInfo.value.baseUserInfoVo : {};
  });
  // 发积分
  const handleScore = inject('handleScore');
  // 发券
  const handleCoupon = inject('handleCoupon');
  // 查看明细
  const viewScoreStatistics = inject('viewScoreStatistics');
  const viewGrowthStatistics = inject('viewGrowthStatistics');
  const statisticsSearch = inject('statisticsSearch');
  const statisticsSearchParam = inject('statisticsSearchParam');

  // 打开明细弹窗
  const openStatisticsDialog = type => {
    statisticsSearchParam.value = {
      userId: baseUserInfoVo.value.userId,
      type
    };
    statisticsSearch();
    if (type === 1) {
      viewScoreStatistics(baseUserInfoVo.value);
      return;
    }
    viewGrowthStatistics(baseUserInfoVo.value);
  };
  return {
    memberInfo,
    baseUserInfoVo,
    handleScore,
    handleCoupon,
    openStatisticsDialog
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .member-info {
    padding: 0 10px;
    display: flex;
    &-box {
      flex: 1;
      &-title {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
      }
      &-content {
        display: flex;
        justify-content: center;
      }
      &-text {
        padding: 12px 0;
        font-size: 14px;
        color: #606266;
      }
    }
  }
</style>
